import React, { useState } from "react";
import { Navbar, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Navbar.css";

function CustomNavbar() {
  const [navOpen, setNavOpen] = useState(false);

  const toggleNav = () => setNavOpen(!navOpen);

  const handleLinkClick = () => {
    setNavOpen(false); // Close fullscreen nav after clicking a link
  };

  return (
    <>
      <Navbar expand="lg" variant="dark" fixed="top" className="navbar-transparent px-5">
        <Container fluid className="d-flex justify-content-between align-items-center">
          {/* Logo */}
          <Navbar.Brand as={Link} to="/" className="fw-bold text-white">
            <img src="/logo.png" alt="logo" className="img-fluid logo-img" />
          </Navbar.Brand>

          {/* Right-side: Contact + Burger */}
          <div className="d-flex align-items-center">
            {/* <div className="contact-number text-white me-5 pulse">
              <span style={{ fontSize: 30 }}>Hotline:</span> 075 123 1234
            </div> */}
            <button type="button" className="open-nav" onClick={toggleNav}>
              <span></span>
            </button>
          </div>
        </Container>
      </Navbar>



      {/* Fullscreen Overlay Menu */}
      <nav className={`fullscreen-nav ${navOpen ? "open" : ""}`}>
        <button type="button" className="close-nav" onClick={toggleNav}>
          &times;
        </button>
        <div className="nav-inner">
          <ul>
            <li><Link to="/" onClick={handleLinkClick}>Home</Link></li>
            <li><Link to="/numbers" onClick={handleLinkClick}>Numbers</Link></li>
            <li><Link to="/#" onClick={handleLinkClick}>About</Link></li>
            <li><Link to="/#" onClick={handleLinkClick}>Contact Us</Link></li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default CustomNavbar;
